/**
 * Safe fallback for hosts that have not applied the server root redirect.
 * It exposes no operational data or actions; the integrated console is the
 * only supported application and messaging entry.
 */
export default function App() {
  return (
    <main className="app-shell">
      <section className="panel" aria-live="polite">
        <h1>Opening SmartProperties</h1>
        <p>The integrated console is the supported place to review dwellings, devices and messages.</p>
        <a className="primary-button" href="/console">Continue to SmartProperties</a>
      </section>
    </main>
  );
}
